import React from 'react'

const CustomCalendarSVG = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4 absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-500 dark:text-customWhite pointer-events-none"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
        >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10m-11 8h12a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
    )
}

export default CustomCalendarSVG